import { render, staticRenderFns } from "./ResultsA.vue?vue&type=template&id=0b505d99&"
import script from "./ResultsA.vue?vue&type=script&lang=js&"
export * from "./ResultsA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports